import React from 'react';
import { ArrowRight } from 'lucide-react';
const HeroSection = () => {
  return <section className="pt-32 pb-20 md:pt-40 md:pb-32 px-4 md:px-6" data-id="element-77">
      <div className="container mx-auto max-w-6xl" data-id="element-78">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-79">
          <div className="space-y-8" data-id="element-80">
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-light leading-tight tracking-tighter" data-id="element-81">
              AI-Powered <br data-id="element-82" />
              <span className="font-normal" data-id="element-83">Facebook Ad</span> <br data-id="element-84" />
              Analysis
            </h1>
            <p className="text-gray-600 text-lg md:text-xl max-w-md leading-relaxed" data-id="element-85">
              Optimize your Facebook ads with AI-powered analysis and automated
              posting.
            </p>
            <div className="pt-4" data-id="element-86">
              <button className="group flex items-center bg-black text-white px-8 py-4 text-sm tracking-wider hover:bg-gray-900 transition-colors" data-id="element-87">
                Get Started
                <ArrowRight size={16} className="ml-2 group-hover:translate-x-1 transition-transform" data-id="element-88" />
              </button>
            </div>
          </div>
          <div className="relative h-[400px] md:h-[500px] bg-gray-50 rounded-sm overflow-hidden" data-id="element-89">
            <div className="absolute inset-0 flex items-center justify-center" data-id="element-90">
              <div className="w-3/4 h-3/4 bg-gray-100 rounded-sm flex items-center justify-center" data-id="element-91">
                <div className="w-2/3 h-2/3 bg-gray-200 rounded-sm flex items-center justify-center" data-id="element-92">
                  <div className="w-1/2 h-1/2 bg-gray-300 rounded-sm" data-id="element-93"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default HeroSection;